import React, { useEffect, useState } from 'react'
import axios from "axios";
import { appConfig } from '../../../../../tools/AppConfig';
import Card from "../../../components/card_v2/card.js";
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";
import Waiting from '../../../components/waiting/waiting_v2';

function RightSide(props) {
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [initialDiscountDetails, setInitialDiscountDetails] = useState(null);
  const [discountDetails, setDiscountDetails] = useState(null);  
  const [cardNumber, setCardNumber] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [cardCvv, setCardCvv] = useState("");
  const [cardExpiry, setCardExpiry] = useState("");
  const [cardDataValid, setCardDataValid] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [userData, setUserData] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(false);
  const [discountMessage, setDiscountMessage] = useState('');
  
  useEffect(() => {
    load_initial_discount_details();
    decodePaymentToken();
  }, [])

  // decode payment token
  const decodePaymentToken = () => {
    // decode from base64 format
    let base64 = base64_decode(props.payment_token);
    // decode from jwt format
    let jwt = jwt_decode(base64);
    setUserData(jwt);
  }

  const cardNumberChange = (number) => {
    //set card number value
    setCardNumber(number);
    setDiscountMessage('');
    setDisplayMessage(false);
    //check for discount
    if(number.length >= 19){ //16 for card number + 3 Input spaces
      load_discount_details(number);
    }
    if(number.length < 16){
      setDiscountDetails(null);
    }
  }
  const cardHolderChange = (holder) => {
    setCardHolder(holder);
  }
  const cardCvvChange = (cvv) => {
    setCardCvv(cvv);
  }
  const cardExpiryChange = (exDate) => {
    setCardExpiry(exDate);
  }
  const cardValidChange = (dataValid) => {
    setCardDataValid(dataValid);
  }
  const saveCardChange = (value) => {
    setSaveCard(value)
  }  
  const load_initial_discount_details = () => {
    setWaiting(true);
    let url;
    let data;
    if(props.platform==="iframe"){
      url = appConfig.getServerUrl() + "/api/acceptance/transaction_discount";
      data = {
        "payment_token": props.payment_token,
        "identifier": "0000000000000000",
        "subtype": "CARD"
      }
    }else if(props.platform==="standalone") {
      url = appConfig.getServerUrl() + `/api/acceptance/invoice_discount`;
      data = {
        "token": props.payment_token,
        "identifier": "0",
        "integration_id": props.userData.integration_ids.VPC
      }
    }
     
    let jsonData = JSON.stringify(data);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(
        url,
        jsonData,
        config
    )
    .then((resp)=>{
      setWaiting(false);
      setInitialDiscountDetails(resp.data)
    })
    .catch((err)=>{
      setWaiting(false);
    });
  }
  const load_discount_details = (number) => {
    let url;
    let data;
    if(props.platform==="iframe"){
      url = appConfig.getServerUrl() + "/api/acceptance/transaction_discount";
      data = {
        "payment_token": props.payment_token,
        "identifier": number.replaceAll(" ", ""),
        "subtype": "CARD"
      }
    }else if(props.platform==="standalone") {
      url = appConfig.getServerUrl() + `/api/acceptance/invoice_discount`;
      data = {
        "token": props.payment_token,
        "identifier": number.replaceAll(" ", ""),
        "integration_id": props.userData.integration_ids.VPC
      }
    }
    let jsonData = JSON.stringify(data);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(
        url,
        jsonData,
        config
    )
    .then((resp)=>{
      setDiscountDetails(resp.data)
    })
    .catch((err)=>{
      setDisplayMessage(err.response.data.display_message);
      setDiscountMessage(err.response.data.message);
    });
  }
  const getFirstName = (fullName) => {
    var namesArr = fullName.split(" ");
    return namesArr[0]
  }
  const getLastName = (fullName) => {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
  }
  const handle_tokenization = () => {
    setWaiting(true);
    let url = appConfig.getServerUrl() + '/api/acceptance/tokenization?payment_token=' + props.payment_token;
    let data = {
      "pan": cardNumber.replaceAll(" ", ""),
      "expiry_month": cardExpiry.split("/")[0].replaceAll(" ", ""),
      "expiry_year": cardExpiry.split("/")[1].replaceAll(" ", ""),
      "cardholder_name": cardHolder,
      "order_id": userData.order_id,
      "email": userData.billing_data.email,
    }
    let config = {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    let jsonData = JSON.stringify(data);
    axios.post(
      url,
      jsonData,
      config
    )
    .then((resp)=>{
      submitPayment();
    })
    .catch((err)=>{
      setWaiting(false)
      setError(true);
      if(err.response && err.response.data[0]){
        setErrorMessage(err.response.data[0]);
      }else{
        setErrorMessage("Something went wrong, Please try again");
      }
    });
  }
  const submitPayment = () => {
    setWaiting(true);
    localStorage.removeItem("trnx_id");
    let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
    let data = {
      "source": {
        "identifier": cardNumber.replaceAll(" ", ""),
        "sourceholder_name": cardHolder,
        "subtype": "CARD",  
        "expiry_month": cardExpiry.split("/")[0].replaceAll(" ", ""),
        "expiry_year": cardExpiry.split("/")[1].replaceAll(" ", ""),
        "cvn": cardCvv,
      },
      "payment_token": props.payment_token
    }

    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    let jsonData = JSON.stringify(data);
    axios.post(
        url,
        jsonData,
        config
    )
    .then((resp)=>{
      if (resp.data.redirection_url) {
        // we should redirect user to this url
        setWaiting(false);
        window.location.replace(resp.data.redirection_url);
      }  else if (resp.data.success == "true" && resp.data.pending == "false") {
        setWaiting(false);
        props.renderSuccess(resp.data.amount_cents, resp.data["source_data.pan"], resp.data["source_data.type"]);
      } else if (resp.data.success == "false" && resp.data.pending == "false") {
      }

    })
    .catch((err)=>{
      setError(true);
      setWaiting(false)
      if (err.response.status === 500) {
        setErrorMessage("Something went wrong, Please try again");
      }else if (err.response.status === 401) {
        setErrorMessage(err.message)
      } else {
        setErrorMessage(err.message)

      }
    });
  }
  const handleProductInvoiceSubmit = (card_data) => {
    setWaiting(true);
    props.disableAllPaymentMethods();
    let url;
    if(props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ props.userData.token;
    }else if(props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ props.userData.token;
    }
    let paymentDict;
    if(props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier": cardNumber.replaceAll(" ", ""),
                "sourceholder_name": cardHolder,
                "expiry_month": cardExpiry.split("/")[0].replaceAll(" ", ""),
                "expiry_year": cardExpiry.split("/")[1].replaceAll(" ", ""),
                "cvn": cardCvv,
                "subtype": "CARD",
                "save_card": saveCard
            }, 
            "shipping_data": {
                'apartment': "",
                'email': props.userData.order_email,
                'floor': "",
                'first_name': getFirstName(props.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': props.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': getLastName(props.userData.order_full_name),
                'state': "",
                'extra_description': ''
            },
            "token": props.userData.token,
            "integration_id": props.userData.integration_ids.VPC,
            "save_card": saveCard
        };
        if(props.deliveryNeed){
            paymentDict.shipping_data.first_name = getFirstName(props.deliveryData.name);
            paymentDict.shipping_data.last_name = getLastName(props.deliveryData.name);
            paymentDict.shipping_data.phone_number = props.deliveryData.phone;
            paymentDict.shipping_data.email = props.deliveryData.email;
            paymentDict.shipping_data.country = props.deliveryData.country;
            paymentDict.shipping_data.state = props.deliveryData.state;
            paymentDict.shipping_data.city = props.deliveryData.city;
            paymentDict.shipping_data.building = props.deliveryData.building;
            paymentDict.shipping_data.street = props.deliveryData.street;
            paymentDict.shipping_data.floor = props.deliveryData.floor;
            paymentDict.shipping_data.apartment = props.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = props.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = props.deliveryData.notes;
        }
    }else if(props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": props.deliveryNeed,
                "amount_cents": props.userData.amount * props.quantity * 100,
                "currency": props.userData.currency,
                "shipping_data": {
                    "first_name": getFirstName(props.deliveryData.name),
                    "last_name": getLastName(props.deliveryData.name),
                    "phone_number": props.deliveryData.phone,
                    "email": props.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": props.userData.product.product_name,
                    "amount_cents": props.userData.amount * 100,
                    "quantity": props.quantity,
                }]
            },
            "source": {
                "identifier": card_data.cardNumber,
                "sourceholder_name": card_data.name,
                "expiry_month": card_data.expiry_mm,
                "expiry_year": card_data.expiry_yy,
                "cvn": card_data.cvc,
                "subtype": "CARD"
            },
            "token": props.userData.token,
            "integration_id": props.userData.integrations.VPC,
        };
        if(props.deliveryNeed){
            paymentDict.order_data.shipping_data.country = props.deliveryData.country;
            paymentDict.order_data.shipping_data.state = props.deliveryData.state;
            paymentDict.order_data.shipping_data.city = props.deliveryData.city;
            paymentDict.order_data.shipping_data.building = props.deliveryData.building;
            paymentDict.order_data.shipping_data.street = props.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = props.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = props.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = props.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = props.deliveryData.notes;
        }
    }


    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, jsonPaymentDict, config)
    .then((resp) => {
      //enable payment methods
      props.enableAllPaymentMethods();
      //show result
      if(resp.data.success === true){
        if (resp.data.url) {
            window.location.href = resp.data.url;
        }else {
          //stop waiting
          setWaiting(false);
          if(props.deliveryNeed){
              //succes without url and delivery
              props.setReqComplete({head: 'Transaction successful', body:'The Courier will be in touch to determine the exact collection time.'});
          }else{
              //succes without url and not delivery
              props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
          }
        }
      }else{
        props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
      }
    })
    .catch((err) => {
      setWaiting(false);
      props.enableAllPaymentMethods();
      if(err.response.data && Array.isArray(err.response.data)  && err.response.data[0]){
        props.setReqComplete({head: 'Transaction declined', body: err.response.data[0]});
      }else{
        props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
      }
    });
  }

  return (
    <div className='right'>
      <Card 
        can_save_card={props.userData && props.userData.can_save_card} 
        saveCard={saveCardChange} 
        cardNumber={cardNumberChange} 
        cardHolder={cardHolderChange} 
        cardCvv={cardCvvChange} 
        cardExpiry={cardExpiryChange} 
        cardValid={cardValidChange} 
        waiting={waiting} 
      />
      {(displayMessage == true && discountMessage) ?
        <div className='discount-message'>
          {discountMessage}
        </div>
        :
        <>
        {discountDetails ? (<>
          <div className={waiting ? "discount-details blur" : "discount-details"}>
            <div className="amount">
              <p>Subtotal</p>
              <p className='sub-total'>EGP {discountDetails.original_amount_cents/100}</p>
            </div>
            <div className="amount">
              <p>Discount</p>
              <p className='discount'>- EGP {discountDetails.discounted_amount_cents/100}</p>
            </div>
            <hr />
            <div className="amount">
              <p>Total amount</p>
              <p className='total'>EGP {discountDetails.original_amount_cents/100}</p>
            </div>
            <div className="single-amount">
              <p>EGP {discountDetails.discount_amount_cents/100}</p>
            </div>    
          </div>
          </>) : 
          initialDiscountDetails && (<>
            <div className={waiting ? "discount-details blur" : "discount-details"}>
              <div className="amount">
                <p>Subtotal</p>
                <p className='sub-total'>EGP {initialDiscountDetails.original_amount_cents/100}</p>
              </div>
              <div className="amount">
                <p>Discount</p>
                <p className='discount'>- EGP {initialDiscountDetails.discounted_amount_cents/100}</p>
              </div>
              <hr />
              <div className="amount">
                <p>Total amount</p>
                <p className='total'>EGP {initialDiscountDetails.original_amount_cents/100}</p>
              </div>
              <div className="single-amount">
                <p>EGP {initialDiscountDetails.discount_amount_cents/100}</p>
              </div>    
            </div>
          </>)
        }
        </>}
      {(!discountDetails && !initialDiscountDetails && props.totalAmount || displayMessage == true) &&
        <div className={waiting ? "discount-details blur" : "discount-details"}>
          <div className="amount">
            <p>Total Amount</p>
            <p>EGP {props.totalAmount/100}</p>
          </div>    
        </div>
      }
      <div className={waiting ? "discount-details blur" : "discount-details"}>
        <div className='accept-terms-2'>
          <p>By completing this payment, you hereby agree to our <span className="colored-terms" onClick={() => props.openTermsModal()}>Terms and Conditions</span></p>
        </div>
        <button className="btn btn-primary active premBtn" disabled={!cardDataValid || waiting} onClick={props.platform==="iframe"?handle_tokenization:handleProductInvoiceSubmit}>{waiting ? <Waiting /> : "Pay Now"}</button>
        {error && <p className='errorMessage'>{errorMessage}</p>}
      </div>
    </div>
  )
}

export default RightSide